<template>
  <div class="timezone-clock">{{ display }}</div>
</template>

<script>
// Live wall-clock time in an IANA timezone (e.g. "America/Edmonton").
// Owns its own timer so the parent form isn't re-rendered every second.
export default {
  props: {
    timeZone: { type: String, default: null },
  },
  data() {
    return {
      now: new Date(),
      timer: null,
    };
  },
  computed: {
    display() {
      if (!this.timeZone) return "Select a timezone";
      try {
        return new Intl.DateTimeFormat("en-US", {
          timeZone: this.timeZone,
          weekday: "short",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
          second: "2-digit",
          timeZoneName: "short",
        }).format(this.now);
      } catch (e) {
        // Intl throws RangeError on an unknown timezone id
        return "Invalid timezone";
      }
    },
  },
  mounted() {
    this.timer = setInterval(() => { this.now = new Date(); }, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.timezone-clock {
  padding: 10px;
  font-variant-numeric: tabular-nums;
  font-size: 1rem;
}
</style>
